import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { clientEnv } from '@retailer-platform/dashboard/env'
import { ChakraProvider } from '@chakra-ui/react'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  massopsViewOnlyAccessControl,
  massopsAdminAccessControl,
  massopsViewAndOperateAccessControl,
} from '../access-control/massopsAccess.configuration'

const MassopsDashboardPage = lazy(() => import('../pages/dashboard/MassopsDashboardPage'))
const MassopsInterventionsPage = lazy(
  () => import('../pages/interventions/MassopsInterventionsPage')
)
const MassopsInterventionPage = lazy(() => import('../pages/intervention/MassopsInterventionPage'))
const MassopsCreateInterventionPage = lazy(
  () => import('../pages/create-intervention/MassopsCreateInterventionPage')
)
const MassopsInterventionSettingsPage = lazy(
  () => import('../pages/intervention-settings/MassopsInterventionSettingsPage')
)
const MassopsApprovalRequestPage = lazy(
  () => import('../pages/approval-request/MassopsApprovalRequestPage')
)
const MassopsAdminPage = lazy(() => import('../pages/admin/MassopsAdminPage'))
const MassopsChatPage = lazy(() => import('../pages/chat/MassopsChatPage'))
// @hygen:inject page-import

// The MassOps chat assistant is not yet ready for production. Gate the route to
// non-production environments so it cannot be reached on prod, even via direct URL.
// TODO(PL-66805): Remove this gate (expose the route in production) once the
// ChatWithAgent backend is wired up and testing is complete.
const isNonProduction = clientEnv.PUBLIC_CLIENT_ENVIRONMENT !== 'production'

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const massopsRouter = (
  <DomainRoute route="massops">
    <ChakraProvider>
      <DashSwitch>
        <DomainRoute
          exact
          route="massops-dashboard"
          component={MassopsDashboardPage}
          accessControl={massopsViewOnlyAccessControl}
        />
        <DomainRoute
          exact
          route="massops-interventions"
          component={MassopsInterventionsPage}
          accessControl={massopsViewOnlyAccessControl}
        />
        <DomainRoute
          exact
          route="massops-intervention"
          component={MassopsInterventionPage as React.ComponentType<any>}
          accessControl={massopsViewOnlyAccessControl}
        />
        <DomainRoute
          exact
          route="massops-create-intervention"
          component={MassopsCreateInterventionPage as React.ComponentType<any>}
          accessControl={massopsViewAndOperateAccessControl}
        />
        <DomainRoute
          exact
          route="massops-intervention-settings"
          component={MassopsInterventionSettingsPage as React.ComponentType<any>}
          accessControl={massopsViewOnlyAccessControl}
        />
        <DomainRoute
          exact
          route="massops-approval-request"
          component={MassopsApprovalRequestPage as React.ComponentType<any>}
          accessControl={massopsViewOnlyAccessControl}
        />
        <DomainRoute
          exact
          route="massops-admin"
          component={MassopsAdminPage as React.ComponentType<any>}
          accessControl={massopsAdminAccessControl}
        />
        {isNonProduction && (
          <DomainRoute
            exact
            route="massops-chat"
            component={MassopsChatPage as React.ComponentType<any>}
            accessControl={massopsViewOnlyAccessControl}
          />
        )}
        {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
      </DashSwitch>
    </ChakraProvider>
  </DomainRoute>
)
